<template>
  <transition name="fade">
    <div class="global-component" v-if="isOffline">
      <div class="text">オフラインです。ネットワーク接続状況を確認してください。</div>
    </div>
  </transition>
</template>
<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  created() {
    /* eslint-disable no-restricted-globals */
    addEventListener("offline", this.offline);
    addEventListener("online", this.online);
  },
  beforeDestroy() {
    removeEventListener("offline", this.offline);
    removeEventListener("online", this.online);
    /* eslint-enable no-restricted-globals */
  },
  data() {
    return {
      isOffline: false,
    };
  },
  methods: {
    /** オフラインになった時 */
    offline() {
      this.isOffline = true;
    },
    online() {
      this.isOffline = false;
    },
  },
});
</script>
<style lang="scss" scoped>
.global-component {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 10000;
  background-color: rgba($color: #ff0000, $alpha: 0.75);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.text {
  color: white;
  font-size: large;
  font-weight: bolder;
  padding: $margin-s;
}
</style>
